import { buildSlice, CommonState } from '~libs/reduxUtils';

import { ClientContribution } from '~support-at-home/models';

import { getAll, typePrefix, uploadFile } from '~support-at-home/actions/clientContributions';

type State = CommonState<ClientContribution>;

const initialState: State = {
  loading: 'idle',
  hasLoaded: false,
  error: null,
  uploadError: null,
  rows: [],
};

const slice = buildSlice<State, ClientContribution>(typePrefix, initialState, {
  extraReducers(builder) {
    builder.addCase(uploadFile.rejected, (state, action) => {
      state.uploadError = action.payload as string;
    });
  },
  customActions: {
    clear(state) {
      state.rows = [];
    },
    clearError(state) {
      state.uploadError = null;
      state.error = null;
    },
  },
  commonConfig: { getAll },
});

export const { clear, clearError } = slice.actions;
export default slice.reducer;
